import { gql } from "graphql-request";
import { useState } from "react";
import { gqlClient } from "../configs/api-config";
import { useToast } from "digiwash-components";
import { formatAndRaiseError } from "../helpers/general";

export function useCancelOrder() {
  let [loadingCancelOrder, setLoadingCancelOrder] = useState(false);
  let toast = useToast();
  function cancelOrder(orderId) {
    setLoadingCancelOrder(true);
    let id = `or_${orderId}`;
    return gqlClient
      .request(
        gql`
          mutation cancelOrder($id: String!) {
            markOrderAsCanceled(order: $id) {
              latest_status
            }
          }
        `,
        {
          id: id,
        }
      )
      .then((data) => {
        toast.show("سفارش به درخواست شما لغو شد.", {
          data: { type: "success" },
        });
        return data;
      })
      .catch(formatAndRaiseError)
      .catch((error) => {
        toast.show(error, {
          data: { type: "danger" },
        });
      })
      .finally(() => {
        setLoadingCancelOrder(false);
      });
  }

  return { cancelOrder, loadingCancelOrder };
}
